import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M4.85766 6.96459c-.51229.258-1.14379.1979-1.58485-.14079l-.08531-.07139-.5075-.46005v2.41528l.5075-.46005.08531-.07139c.41173-.31617.98926-.38991 1.48094-.18839l.10391.0476L13.32 12.2968V2.70216L4.85766 6.96459ZM15 12.7291c-.0001.9073-1.0082 1.5016-1.9031 1.1849l-.1772-.0754-8.69423-4.37941-.83563.75851c-.88193.7994-2.38977.2333-2.38984-.89732V5.67962c.00007-1.09522 1.41536-1.66109 2.30563-.96869l.08421.07138.83563.75751 8.69423-4.37844.1772-.07535c.8949-.316726 1.903.27761 1.9031 1.18483V12.7291Z';
const draw24px =
  'M20.25 3.28616 6.97656 10.7969c-.46165.2612-1.0342.2014-1.43066-.1396l-.07715-.0723L3.75 8.83401v6.33109l1.71875-1.75.07715-.0723c.37014-.3184.89339-.3917 1.33691-.1875l.09375.0479L20.25 20.7129V3.28616Zm1.5 17.85644c0 .9573-1.032 1.5591-1.8652 1.0879L6.40332 14.6026 4.3916 16.6524c-.78401.7985-2.14137.2439-2.1416-.875V8.22268c.00022-1.08391 1.27397-1.63839 2.06641-.94629l.07519.07129 2.01172 2.04883L19.8848 1.76956l.1582-.07617c.7999-.31862 1.707.26657 1.707 1.16406V21.1426Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const AnnouncementIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowDown'),
) as IconWithRender;

AnnouncementIcon.displayName = 'AnnouncementIcon';
AnnouncementIcon.propTypes = Icon.propTypes;
AnnouncementIcon.renderIcon = (props) => <AnnouncementIcon {...props} />;
export default AnnouncementIcon;
